import React, { useEffect, useState } from "react";

import { Link, useParams } from "react-router-dom";
import { Col, Row, Spinner } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";

import { PatientCard } from "./PatientCard";
import { getPatientList } from "../../../../../redux/actions/dbactions/pateints";

export const ProfileListOrder = () => {
  const dispatch = useDispatch();
  const { serviceID } = useParams();
 
  useEffect(() => {
    dispatch(getPatientList());
  }, [dispatch, serviceID]);
  const { patientsList, isLoading, currentData, bookingData } = useSelector(
    (state) => state.patients
  );
  const patientsLists = patientsList.usr?.svcUserProfile || [];
  const [selectedId, setSelectedId] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [isDisabled, setIsDisabled] = useState(null);
  const HandleClick = (id) => {
    setSelectedColor(selectedColor === id ? null : id);
    setIsDisabled(isDisabled === id ? null : id);
  };

  return (
    <div>
      <div className="ser_title_b">
        <h5>Patient List x</h5>

        <Link to={`/dashboard/explore/add-patient`} className="sign_btn">
          Add New Profile
        </Link>
      </div>
      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : null}
      <Row>
        {patientsLists.length > 0 ? (
          patientsLists.map((item, index) => (
            <Col className="mb-3" lg={4} md={6} key={index}>
              <PatientCard
                data={item}
                HandleClick={() => HandleClick(item.svcuser_profile_id)}
                selectedColor={selectedColor}
                isDisabled={isDisabled}
                currentData={currentData}
                bookingData={bookingData}
              />
            </Col>
          ))
        ) : (
          <Col>
            <p className="text-center">No Patients found</p>
          </Col>
        )}
      </Row>
      {/* <DeleteModal
        show={show}
        handleClose={() => setShow(false)}
        selectedTitle={selectedTitle}
        handleDelete={handleDelete}
      />
      <AddModal
        show={addmodal}
        onHide={() => setAddmodal(false)}
        setRefresh={setRefresh}
        setAddmodal={setAddmodal}
        serviceid={facilityId}
      />
      <EditModal
        show={editmodal}
        onHide={() => setEditmodal(false)}
        setRefresh={setRefresh}
        setEditmodal={setEditmodal}
        serviceid={facilityId}
      /> */}
    </div>
  );
};
